import { SELECTION_1, SELECTION_2, SELECTION_3, SELECTION_4, SELECTION_5 } from './constants'
export const MENUS_LIST = [
    {
        name: SELECTION_1,
        key: 'income',
        title: 'Overview',
        type:'md-stats'
    },
    {
        name: SELECTION_2,
        key: 'user',
        title: '历史销售趋势',
        type: 'md-trending-up'
    },
    {
        name: SELECTION_3,
        key: 'new_user',
        title: '销售指标拆解',
        type: 'ios-paper'
    },
    {
        name: SELECTION_5,
        title: '用户类型趋势',
        type: 'md-stats'
    },
    {
        name: SELECTION_4,
        title: '销售数据导出',
        type: 'md-cloud-download'
    },
]
export const ECHARTS_REF_HASH = {
    [SELECTION_1]:'over_view',
    [SELECTION_2]:'history_data',
    [SELECTION_3]:'index_dismantle',
    [SELECTION_5]: 'tendency'

}


